export default "__VITE_ASSET__DZ95hbc3__"